module.exports = __webpack_public_path__ + "static/bloodlands-7d3a1fc9aa3535ea9044e951d6c29ff4.jpg";